// Límites del campo "fecha de nacimiento" (punto 5 de José, 25/09/2026):
// nadie puede tener edad negativa ni más de 120 años. El backend aplica la
// misma regla (App\Support\FechaNacimiento); esto solo evita que el
// calendario ofrezca fechas que después se van a rechazar.

const EDAD_MAXIMA = 120;

const aISO = (fecha) => {
  const mm = String(fecha.getMonth() + 1).padStart(2, '0');
  const dd = String(fecha.getDate()).padStart(2, '0');
  return `${fecha.getFullYear()}-${mm}-${dd}`;
};

const hoy = new Date();
const minima = new Date(hoy.getFullYear() - EDAD_MAXIMA, hoy.getMonth(), hoy.getDate());

export const FECHA_NAC_MIN = aISO(minima);
export const FECHA_NAC_MAX = aISO(hoy);
